import React, { useState } from 'react'
import tw from "twin.macro"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import logo from "../images/cargosailor_logo.png";
import { useHistory } from 'react-router-dom';

const AdminLogin = () => {

    let history = useHistory();

    const [email, setEmail] = useState("");
    const [pass, setPass] = useState("");
    const [error, setError] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault()
        if(email === "admin@cargosailor.com" && pass === "admin") {
            history.push("/admin-board")
        }
        else
            setError(true)
        console.log("working");
    }

    return (
        <div tw="min-h-screen flex items-center justify-center bg-orange-200 py-12 px-4 sm:px-6 lg:px-8">
  <div tw="max-w-md w-full space-y-8 bg-white px-5 py-8 rounded-lg">
    <div>
      <img tw="mx-auto h-12 w-auto" src={logo} alt="Workflow" />
      <h2 tw="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Admin Login
      </h2>
    </div>
    <form tw="mt-8 space-y-6" onSubmit={handleSubmit}>
      {/* <input type="hidden" name="remember" value="true" /> */}
      <div tw="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="email-address" tw="sr-only">Email address</label>
          <input id="email-address" value={email} onChange={(e) => setEmail(e.target.value)} name="email" type="email" autocomplete="email" required tw="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none  focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Email address" />
        </div>
        <div>
          <label htmlhtmlFor="password" tw="sr-only">Password</label>
          <input id="password" value={pass} onChange={(e) => setPass(e.target.value)} name="password" type="password" autocomplete="current-password" required tw="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none  focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Password" />
        </div>
      </div>

      {/* <div tw="flex items-center justify-between">
        <div tw="flex items-center">
          <input id="remember_me" name="remember_me" type="checkbox" tw="h-4 w-4 text-indigo-600 border-gray-300 rounded" />
          <label htmlFor="remember_me" tw="ml-2 block text-sm text-gray-900">
            Remember me
          </label>
        </div>

        <div tw="text-sm">
          <a href="#" tw="font-medium text-indigo-600 hover:text-indigo-500">
            Forgot your password?
          </a>
        </div>
      </div> */}

      <div>
        <button type="submit" className="group" tw="relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-400 hover:bg-orange-500 focus:outline-none ">
          <span tw="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg tw="h-5 w-5 text-orange-500 group-hover:text-orange-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
          </span>
          Sign in
        </button>
      </div>
      {error && <div tw="flex items-center justify-center">
        <div tw="text-sm">
          <p href="#" tw="font-bold text-red-600">
            Check you email and password again!
          </p>
        </div>
      </div>}
    </form>
  </div>
</div>
    )
}

export default AdminLogin
